import { createContext } from 'react';

export const CocktailContext = createContext({
  selectedCocktail: {},
  setSelectedCocktail: selectedCocktail => {},
  fetchedRecommendedCocktailsMap: undefined,
  setFetchedRecommendedCocktailsMap: recommendedCocktailsMap => {},
});
